export default __webpack_public_path__ + "static/media/n3.886676c8.jpg";